import styled, { css } from 'styled-components';

import { CardContent, CardActions } from '@mui/material';

export default styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;

  .campaign-card {
    width: 100%;
    padding: 8px;

    :not(:last-child) {
      margin-bottom: 16px;
    }
  }
`;

export const CardContentWrapper = styled(CardContent)`
  padding: 8px 16px !important;
`;

export const CardActionsWrapper = styled(CardActions)`
  padding: 8px 16px !important;
`;

export const ChannelLabel = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4px 8px;
  border-radius: 4px;

  ${({ color }: { color: string }) => css`
    background-color: ${color};
    color: white;

    @supports (background: color-mix(in srgb, ${color}, white 80%)) {
      background-color: color-mix(in srgb, ${color}, white 80%);
      color: ${color};
    }
  `};
`;
